import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { environment } from '@environment';
import { catchError, EMPTY, expand, first, map, type Observable, of, timeout } from 'rxjs';

interface WorkspacePage {
  readonly items: ReadonlyArray<{ readonly id: string; readonly archived?: boolean }>;
  readonly count: number;
}

export const notesWorkspaceGuard: CanActivateFn = (route) => {
  const http = inject(HttpClient);
  const router = inject(Router);
  const spaceId = route.paramMap.get('spaceId');
  const refused = (): false | ReturnType<Router['createUrlTree']> =>
    router.navigated ? false : router.createUrlTree(['/mail']);
  const page = (offset: number): Observable<WorkspacePage> =>
    http.get<WorkspacePage>(`${environment.baseUrl}/api/account/spaces`, { params: { limit: 100, offset } });

  if (!spaceId) {
    return refused();
  }

  return page(0).pipe(
    expand((response, index) =>
      response.items.length > 0 && (index + 1) * 100 < response.count ? page((index + 1) * 100) : EMPTY,
    ),
    map((response) => response.items.some((workspace) => workspace.id === spaceId && !workspace.archived)),
    first((accepted) => accepted, false),
    timeout({ first: 10_000 }),
    map((accepted) => accepted || refused()),
    catchError(() => of(refused())),
  );
};
